"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Polyfill = void 0;
const Promise_1 = require("./Promise");
const Events_1 = require("./Events");
const _lib_1 = require("./_lib");
const root = (typeof global !== "undefined" && global) ||
    (typeof window !== "undefined" && window);
class Polyfill {
    static ensureEnabled() {
        if (Polyfill.enabled)
            return;
        Polyfill.enabled = true;
        // Polyfill Promise
        root.Promise = Promise_1.PromiseWithContext;
        // Polyfill Timers
        root.setTimeout = (0, _lib_1.withContext)(root.setTimeout);
        root.setInterval = (0, _lib_1.withContext)(root.setInterval);
        root.setImmediate = (0, _lib_1.withContext)(root.setImmediate);
        EventTarget.prototype.addEventListener = Events_1.addEventListenerWithContext;
        EventTarget.prototype.dispatchEvent = Events_1.dispatchWithContext;
    }
}
exports.Polyfill = Polyfill;
Polyfill.originalSetTimeout = setTimeout;
Polyfill.OriginalPromise = Promise_1.OriginalPromise;
Polyfill.enabled = false;
//# sourceMappingURL=Polyfill.js.map